// Custom icons: some of the icons' design is changed by Andreas. We should add
// those kind of icons to here
import CheckCustomIcon from "@/assets/svg/custom/check.svg";
import IBGCustomIcon from "@/assets/svg/custom/ibg.svg?component";

// Light FontAwesome Icons
import FilePdfLightIcon from "@/assets/svg/light/file-pdf.svg?component";
import ArrowUpLightIcon from "@/assets/svg/light/arrow-up.svg?component";

// Regular FontAwesome Icons
import BarsFilterRegularIcon from "@/assets/svg/regular/bars-filter.svg?component";
import BellRegularIcon from "@/assets/svg/regular/bell.svg?component";
import BowlHotRegularIcon from "@/assets/svg/regular/bowl-hot.svg?component";
import BuildingRegularIcon from "@/assets/svg/regular/building.svg?component";
import CalendarRegularIcon from "@/assets/svg/regular/calendar.svg?component";
import CircleQuestionRegularIcon from "@/assets/svg/regular/circle-question.svg?component";
import ClockRegularIcon from "@/assets/svg/regular/clock.svg?component";
import CopyRegularIcon from "@/assets/svg/regular/copy.svg?component";
import ImageRegularIcon from "@/assets/svg/regular/image.svg?component";
import ListRegularIcon from "@/assets/svg/regular/list.svg?component";
import MagnifyingGlassRegularIcon from "@/assets/svg/regular/magnifying-glass.svg?component";
import PenToSquareRegularIcon from "@/assets/svg/regular/pen-to-square.svg?component";
import TrashCanRegularIcon from "@/assets/svg/regular/trash-can.svg?component";
import DownloadRegularIcon from "@/assets/svg/regular/download.svg?component";
import ElipsisVerticalRegularIcon from "@/assets/svg/regular/elipsis-vertical.svg?component";
import EyeRegularIcon from "@/assets/svg/regular/eye.svg?component";
import FileLinesRegularIcon from "@/assets/svg/regular/file-lines.svg?component";
import FloppyDiskRegularIcon from "@/assets/svg/regular/floppy-disk.svg?component";
import Grid2RegularIcon from "@/assets/svg/regular/grid-2.svg?component";
import GripLinesRegularIcon from "@/assets/svg/regular/grip-lines.svg?component";
import IdCardRegularIcon from "@/assets/svg/regular/id-card.svg?component";
import PrinterRegularIcon from "@/assets/svg/regular/printer.svg?component";
import RepeatRegularIcon from "@/assets/svg/regular/repeat.svg?component";
import ChevronLeftRegularIcon from "@/assets/svg/regular/chevron-left.svg?component";
import ChevronRightRegularIcon from "@/assets/svg/regular/chevron-right.svg?component";
import ChevronDownRegularIcon from "@/assets/svg/regular/chevron-down.svg?component";
import SignOutRegularIcon from "@/assets/svg/regular/sign-out.svg?component";
import SlidersRegularIcon from "@/assets/svg/regular/sliders.svg?component";
import TagRegularIcon from "@/assets/svg/regular/tag.svg?component";
import UserGearRegularIcon from "@/assets/svg/regular/user-gear.svg?component";
import UserRegularIcon from "@/assets/svg/regular/user.svg?component";
import ChevronUpRegularIcon from "@/assets/svg/regular/chevron-up.svg?component";
import CircleCheckRegularIcon from "@/assets/svg/regular/circle-check.svg?component";
import XMarkRegularIcon from "@/assets/svg/regular/xmark.svg?component";

// Solid FontAwesome Icons
import ArrowLeftSolidIcon from "@/assets/svg/solid/arrow-left.svg?component";
import BuildingSolidIcon from "@/assets/svg/solid/building.svg?component";
import CheckSolidIcon from "@/assets/svg/solid/check.svg?component";
import ChevronDownSolidIcon from "@/assets/svg/solid/chevron-down.svg?component";
import ChevronLeftSolidIcon from "@/assets/svg/solid/chevron-left.svg?component";
import ChevronRightSolidIcon from "@/assets/svg/solid/chevron-right.svg?component";
import CircleCheckSolidIcon from "@/assets/svg/solid/circle-check.svg?component";
import CirclePlusSolidIcon from "@/assets/svg/solid/circle-plus.svg?component";
import CircleQuestionSolidIcon from "@/assets/svg/solid/circle-question.svg?component";
import CircleXSolidIcon from "@/assets/svg/solid/circle-x.svg?component";
import ClipboardCheckSolidIcon from "@/assets/svg/solid/clipboard-check.svg?component";
import ClockRotateLeftSolidIcon from "@/assets/svg/solid/clock-rotate-left.svg?component";
import EyeSolidIcon from "@/assets/svg/solid/eye.svg?component";
import FilmSolidIcon from "@/assets/svg/solid/film.svg?component";
import EyeSlashSolidIcon from "@/assets/svg/solid/eye-slash.svg?component";
import HouseUserSolidIcon from "@/assets/svg/solid/house-user.svg?component";
import IdCardSolidIcon from "@/assets/svg/solid/id-card.svg?component";
import ImageSolidIcon from "@/assets/svg/solid/image.svg?component";
import InfoCircleSolidIcon from "@/assets/svg/solid/info-circle.svg?component";
import KeySolidIcon from "@/assets/svg/solid/key.svg?component";
import LoaderSolidIcon from "@/assets/svg/solid/loader.svg?component";
import LockSolidIcon from "@/assets/svg/solid/lock.svg?component";
import MessagesLinesSolidIcon from "@/assets/svg/solid/messages-lines.svg?component";
import MessagesSolidIcon from "@/assets/svg/solid/messages.svg?component";
import PersonRunningSolidIcon from "@/assets/svg/solid/person-running.svg?component";
import PhotoVideoSolidIcon from "@/assets/svg/solid/photo-video.svg?component";
import PlusSolidIcon from "@/assets/svg/solid/plus.svg?component";
import RectangleListSolidIcon from "@/assets/svg/solid/rectangle-list.svg?component";
import RepeatSolidIcon from "@/assets/svg/solid/repeat.svg?component";
import TriangleExclamationSolidIcon from "@/assets/svg/solid/triangle-exclamation.svg?component";
import RightFromBracketSolidIcon from "@/assets/svg/solid/right-from-bracket.svg?component";
import TagSolidIcon from "@/assets/svg/solid/tag.svg?component";
import TrashCanSolidIcon from "@/assets/svg/solid/trash-can.svg?component";
import XMarkSolidIcon from "@/assets/svg/solid/xmark.svg?component";
import UserGearSolidIcon from "@/assets/svg/solid/user-gear.svg?component";
import UserSolidIcon from "@/assets/svg/solid/user.svg?component";
import UsersSolidIcon from "@/assets/svg/solid/users.svg?component";
import UtensilsSolidIcon from "@/assets/svg/solid/utensils.svg?component";
import HouseSolidIcon from "@/assets/svg/solid/house.svg?component";

export const SVGIcons = {
  // custom
  "custom-check": CheckCustomIcon,
  "custom-ibg": IBGCustomIcon,

  // light
  "fal-file-pdf": FilePdfLightIcon,
  "fal-arrow-up": ArrowUpLightIcon,

  // regular
  "far-bars-filter": BarsFilterRegularIcon,
  "far-bell": BellRegularIcon,
  "far-bowl-hot": BowlHotRegularIcon,
  "far-building": BuildingRegularIcon,
  "far-calendar": CalendarRegularIcon,
  "far-circle-question": CircleQuestionRegularIcon,
  "far-clock": ClockRegularIcon,
  "far-copy": CopyRegularIcon,
  "far-image": ImageRegularIcon,
  "far-list": ListRegularIcon,
  "far-magnifying-glass": MagnifyingGlassRegularIcon,
  "far-pen-to-square": PenToSquareRegularIcon,
  "far-trash-can": TrashCanRegularIcon,
  "far-download": DownloadRegularIcon,
  "far-elipsis-vertical": ElipsisVerticalRegularIcon,
  "far-eye": EyeRegularIcon,
  "far-file-lines": FileLinesRegularIcon,
  "far-floppy-disk": FloppyDiskRegularIcon,
  "far-grid-2": Grid2RegularIcon,
  "far-grip-lines": GripLinesRegularIcon,
  "far-id-card": IdCardRegularIcon,
  "far-printer": PrinterRegularIcon,
  "far-repeat": RepeatRegularIcon,
  "far-chevron-left": ChevronLeftRegularIcon,
  "far-chevron-right": ChevronRightRegularIcon,
  "far-chevron-down": ChevronDownRegularIcon,
  "far-sign-out": SignOutRegularIcon,
  "far-sliders": SlidersRegularIcon,
  "far-tag": TagRegularIcon,
  "far-user-gear": UserGearRegularIcon,
  "far-user": UserRegularIcon,
  "far-chevron-up": ChevronUpRegularIcon,
  "far-circle-check": CircleCheckRegularIcon,
  "far-xmark": XMarkRegularIcon,

  // solid
  "fas-arrow-left": ArrowLeftSolidIcon,
  "fas-building": BuildingSolidIcon,
  "fas-check": CheckSolidIcon,
  "fas-chevron-down": ChevronDownSolidIcon,
  "fas-chevron-left": ChevronLeftSolidIcon,
  "fas-chevron-right": ChevronRightSolidIcon,
  "fas-circle-check": CircleCheckSolidIcon,
  "fas-circle-plus": CirclePlusSolidIcon,
  "fas-circle-question": CircleQuestionSolidIcon,
  "fas-circle-x": CircleXSolidIcon,
  "fas-clipboard-check": ClipboardCheckSolidIcon,
  "fas-clock-rotate-left": ClockRotateLeftSolidIcon,
  "fas-eye": EyeSolidIcon,
  "fas-film": FilmSolidIcon,
  "fas-eye-slash": EyeSlashSolidIcon,
  "fas-house-user": HouseUserSolidIcon,
  "fas-id-card": IdCardSolidIcon,
  "fas-image": ImageSolidIcon,
  "fas-info-circle": InfoCircleSolidIcon,
  "fas-key": KeySolidIcon,
  "fas-loader": LoaderSolidIcon,
  "fas-lock": LockSolidIcon,
  "fas-messages-lines": MessagesLinesSolidIcon,
  "fas-messages": MessagesSolidIcon,
  "fas-person-running": PersonRunningSolidIcon,
  "fas-photo-video": PhotoVideoSolidIcon,
  "fas-plus": PlusSolidIcon,
  "fas-rectangle-list": RectangleListSolidIcon,
  "fas-repeat": RepeatSolidIcon,
  "fas-tag": TagSolidIcon,
  "fas-trash-can": TrashCanSolidIcon,
  "fas-triangle-exclamation": TriangleExclamationSolidIcon,
  "fas-right-from-bracket": RightFromBracketSolidIcon,
  "fas-user-gear": UserGearSolidIcon,
  "fas-user": UserSolidIcon,
  "fas-users": UsersSolidIcon,
  "fas-utensils": UtensilsSolidIcon,
  "fas-house": HouseSolidIcon,
  "fas-xmark": XMarkSolidIcon,
} as const;

export type SVGName = keyof typeof SVGIcons;
